import React from 'react';
import { InfoSection } from '../../components';
import { homeObjOne } from './Data';

const SignUp = () => {
  return (
    <>
      <InfoSection {...homeObjOne} />
    </>
  );
}

export default SignUp;
